import { h } from 'preact';
import { Profile } from '../lib/profile';
import { rankById } from '../lib/ranks';


export interface StartPageProps {
    launchGame: () => void;
    resumeCurrentGame: () => void;
    redoTutorial: () => void;
    profile: Profile
    canResume: boolean;
}

export function StartPage({launchGame, resumeCurrentGame, redoTutorial, canResume, profile}: StartPageProps) {
    return (
    <div class="main-menu">
        <h1>v<span class="vowel">o</span>w<span class="vowel">e</span>ls</h1>
        <div class="menu-options">
            { canResume ? <a class="resume-button" onClick={resumeCurrentGame}>Resume Game</a> : null }
            <a onClick={launchGame}>New Game</a>
            <a class="tutorial-button" onClick={redoTutorial}>Tutorial</a>
        </div>
            <div class="rank-section">
                <span class="rank-label">Rank:</span><span class="rank-name">{rankById(profile.rankProgress.rankId).name}</span>
                <div class="rank-progress-bar-wrapper">
                    <div class="rank-progress-bar" style={ {width: profile.rankProgress.progress + "%" }} ></div>
                </div>
            </div>
    </div>
    )
}

